import axios from 'util/axiosConfig';
import { getErrorMessage } from '../util/ErrorUtils';
import fileDownload from "js-file-download";
import { message } from 'antd';

export const fetchHL7QueueAPI = async (params) => {
    let modifiedParams = {
        ...params,
        page: params.page - 1,
        visitNo: params.visitNo === "" ? null : params.visitNo
    }
    return await axios.post(`/api/v1/hl7-queue`, modifiedParams)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const downloadHL7Queue = async (messageControlId) => {
    return await axios.get(`/api/v1/hl7-queue`, {
        params: {
            messageControlId
        }
    })
        .then(function (response) {
            if (response.status === 200) {
                const fileName = messageControlId + '.hl7';
                fileDownload(response.data, fileName);
            } else {
                message.error('Failed to download file!');
            }
        })
        .catch(function (error) {
            message.error('Failed to download file!');
        });
}